"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettings = void 0;
var tslib_1 = require("tslib");
var settings_queries_1 = require("./settings.queries");
var settings_mutations_1 = require("./settings.mutations");
var settings_mappers_1 = require("./settings.mappers");
var PrivateSettings = /** @class */ (function () {
    function PrivateSettings(client) {
        this.client = client;
    }
    PrivateSettings.prototype.get = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(settings_queries_1.GET_SETTINGS)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (0, settings_mappers_1.mapSettingsToVod)(result.settings)];
                }
            });
        });
    };
    PrivateSettings.prototype.update = function (settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(settings_mutations_1.UPDATE_SETTINGS, (0, settings_mappers_1.mapSettingsToGql)(settings))];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (0, settings_mappers_1.mapSettingsToVod)(result.settings.update.entity)];
                }
            });
        });
    };
    return PrivateSettings;
}());
exports.PrivateSettings = PrivateSettings;
//# sourceMappingURL=settings.js.map